export const applyConf = [{
  label: '企业名称',
  field: 'institutionName'
},
{
  label: '申请时间',
  field: 'commitTime'
},
// {
//   label: '申请人状态',
//   field: 'checkState',
//   tabletype: 'tags'
// }, 
// {
//   label: '审核意见',
//   field:'active', //和申请人状态挂钩
//   tabletype: 'anyDo', //未知操作，通过emit向外触发
//   typeField: '查看/dialog'  // 名字/类型
// }
]

